import { Outlet, createFileRoute } from '@tanstack/react-router'

// Layout route para /dashboard/$dashboardId/empreendimentos
// Este arquivo (route.tsx) serve como layout que envolve todas as rotas filhas
// Usando Directory Routes: dashboard.$dashboardId.empreendimentos/route.tsx
// route.tsx = layout route (sempre renderizado)
// Renderiza o <Outlet /> para as rotas filhas (index.tsx, $empreendimentoId/index.tsx, etc)
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/empreendimentos',
)({
  component: function EmpreendimentosLayout() {
    return <Outlet />
  },
})

